import Vue from 'vue';
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
    this.payTypeValidation = function () {
        const dictonary = {
            custom: {
                PayTypeCode: {
                    required: () => t.t(dictEnum.LBL_PayType) + t.t(dictEnum.WARN_IsRequired)
                },
                Desc: {
                    required: () => t.t(dictEnum.LBL_Description) + t.t(dictEnum.WARN_IsRequired)
                },
                Type: {
                    required: () => t.t(dictEnum.LBL_Type) + t.t(dictEnum.WARN_IsRequired)
                },
                Formula: {
                    required: () => t.t(dictEnum.LBL_Formula) + t.t(dictEnum.WARN_IsRequired)
                },
            }
        };
        Validator.localize('en', dictonary);
    }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S082100-PayType/S082100-PayTypeValidation.js